function addListener(target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback)
}
function getEventCoords(event) {
	if (!event) event = window.event
	var coords = {
		x: null,
		y: null
	}
	if (event) {
		coords.x = typeof event.pageX === 'number' ? event.pageX : (typeof event.clientX === 'number' ? event.clientX + document.body.scrollLeft : null)
		coords.y = typeof event.pageY === 'number' ? event.pageY : (typeof event.clientY === 'number' ? event.clientY + document.body.scrollTop : null)
	}
	return coords
}
function isFindElement(nodes, ele) {
	var res = false
	if (nodes && nodes.forEach && ele instanceof HTMLElement) {
		for (var i = 0; i < nodes.length; i++) {
			var node = nodes[i]
			if (ele === node) {
				res = true
			} else if (node.childNodes.length) {
				if (isFindElement(node.childNodes, ele)) {
					res = true
				}
			}
			if (res) break
		}
	}
	return res
}

$(document).ready(function () {

	$('.but-toddle').on('click', function () {
		$('.nav').toggleClass('active');
		$('body').toggleClass('no-scrol');
		$('.search-bar').removeClass('active');
	})
	$('.nav a').on('click', function () {
		var protocol = this.protocol
		if (protocol && protocol.indexOf('http') === -1) return
		$('.nav').removeClass('active');
		$('body').removeClass('no-scroll');
	})
	$('.but-search').on('click', function (e) {
		e.stopPropagation(); // 阻止事件冒泡,防止触发document的点击事件
		
		// 如果搜索框已显示,则隐藏搜索框和蒙版
		if ($('.search-bar').hasClass('active')) {
			$('.search-bar').removeClass('active');
			$('.search-overlay').css({
				opacity: 0,
				visibility: 'hidden'
			});
		} 
		// 如果搜索框未显示,则显示搜索框和蒙版
		else {
			$('.search-bar').addClass('active');
			$('.search-overlay').css({
				opacity: 1,
				visibility: 'visible'
			});
			$('.nav').removeClass('active');
			$('body').removeClass('no-scroll');
		}
	})
	
	$('.filter-toggle').on('click', function () {
		$('.filter').toggleClass('active');

	})
	//------------ select----------

	jQuery('select').select2({
		minimumResultsForSearch: Infinity,
		dropdownPosition: 'below'
	});
	//------------ WOW animate----------
	wow = new WOW({
		offset: 150,
		live: true
	})
	wow.init();

	// -------------------- header --------------------------
	// let to_clips = $('.tabs-product').offset();

	$(window).scroll(function () {
		if ($(this).scrollTop() > 1) {
			$('header').addClass('sticky')
		} else {
			$('header').removeClass('sticky')
		}

		if ($(this).scrollTop() > 200) {
			$('.up').addClass('sticky')
		} else {
			$('.up').removeClass('sticky')
		}

		var $product_content = $('.tabs-product'),
			product_content_offset = $product_content.offset(),
			product_content_next_offset = $product_content.next().offset(),
			$tabs_list = $('.tabs-list', $product_content)
		if (product_content_offset) {
			if ($(this).scrollTop() > product_content_offset.top) {
				$tabs_list.addClass('sticky')
			} else {
				$tabs_list.removeClass('sticky')
			}
		}
		if (product_content_next_offset) {
			var remove_sticky_offset = product_content_next_offset.top - $tabs_list.outerHeight(),
				$header = $('.header>header')
			if (['fixed', 'absolute'].indexOf($header.css('position')) > -1) {
				remove_sticky_offset -= $header.outerHeight()
			}
			if ($(this).scrollTop() >= remove_sticky_offset) {
				$tabs_list.removeClass('sticky')
			}
		}
	})
	$('.up').on('click', function () {
		$('body,html').animate({ scrollTop: 0 }, 800);
	})



	const video = document.getElementById("video")
	if (video) {
		const videoRect = video.getBoundingClientRect();
		window.addEventListener("scroll", (event) => {
			if (video.classList.contains('plays')) {
				if (window.pageYOffset > videoRect.top + 350) {
					video.classList.remove('plays');
					video.play();
					console.log('play');
				};
			}

		});
	}

	// -------------------- svg--------------------------
	function svg() {
		$('img.svg').each(function () {
			var $img = $(this)
			var imgURL = $img.attr('src')
			var attributes = $img.prop('attributes')
			if ($img.hasClass('svg')) {
				$.get(
					imgURL,
					function (data) {
						var $svg = jQuery(data).find('svg')
						$svg = $svg.removeAttr('xmlns:a')
						$.each(attributes, function () {
							$svg.attr(this.name, this.value)
						})
						$img.removeClass('svg').replaceWith($svg)
					},
					'xml'
				)
			}
		})
	}
	svg()

	// ----------------- carousel ----------------------
	let $Slider = $('.slider')
	if ($Slider.length) {
		var $sliderOwl = $('.owl-carousel', $Slider),
			slider_options = {
				loop: true,
				nav: true,
				navText: ['', ''],
				dots: false,
				autoplay: true,
				autoplayTimeout: 5000,
				margin: 1,
				items: 1,
				thumbs: false,
				responsive: {
					0: {
						nav: false,
						dots: true,
					},
					768: {
						nav: true,
						dots: false,
					},
					992: {

					}
				},
				navContainer: '.owl-nav'
			},
			slider_text_selection = function (eve) {
				eve.target.focus()
				if (eve.type === 'touchstart') {
					eve.preventDefault()
				}
				var selection = window.getSelection()
				var range = document.createRange()
				var selected_node = eve.target
				if ($(eve.target).parent().css('user-select') === 'all') {
					selected_node = eve.target.parentElement
				}
				range.selectNodeContents(selected_node)
				selection.removeAllRanges()
				selection.addRange(range)
			},
			$slider_text_eles = $('.slide-item__text span', $sliderOwl)
		/* if ($sliderOwl.find('.slide-item--video').length) {
			slider_options.video = true
		} */
		if ($('.slide-item', $sliderOwl).length < 2) {
			slider_options.mouseDrag = false
			$slider_text_eles.off('dblclick poninterdown touchstart', slider_text_selection)
		} else {
			$slider_text_eles.on('dblclick poninterdown touchstart', slider_text_selection)
		}
		$sliderOwl.on('initialize.owl.carousel', function (event) {
			// 1. 由于为了防止幻灯片区段出现累积布局偏移 (CLS)，事先每个"slide-item"都加了padding-bottom占位空间，初始化后initialize.owl.carousel即（.owl-loaded）又会自动消失，唯一在此期间可查看图片是否加载的中间过程即是初始化时，而如果图片已加载且未脱离padding父级文档流，则高度可能增加一倍导致导航箭头和文本模块（相对父级可能不一致，然而高度一致）一起都有一个"***从下而上的过渡***"（即使transition:none）因此这里可以判断图片的image.naturalWidth和complete属性、视频的XXX来判断当加载成功的项目则应取消padding。
			var $slides = $('.slide-item', this)
			//,$first_slide = $slides.first() //在此初始化事件时，由于".slide-item:not(:first-child) {display: none;}",slide-item未被剪切到owl-item中，非父级的第一个孩子都不会显示，因此不用担心第一张还未加载完成而第二张已经加载好的情况($first_slide.is('.slide-item--image'))。后来发现每个项都必须设置。
			// $slides.each(function (i, ele) {
			// 	var $slide_img = $('picture>img', ele),
			// 		is_img_loaded = $slide_img.length && $slide_img.get(0).naturalWidth ? true : false
			// 	if (is_img_loaded) {
			// 		$(ele).addClass('img-loaded') //虽然在".owl-loaded"后没有了padding-bottom，但是必须每个都在jQuery内部告诉其被置为了0。
			// 	}
			// })
			// $slides.css('padding-bottom', '0')
			$slides.each(function (i, ele) { //对执行完initialize.owl.carousel即添加好".owl-loaded"后首张幻灯片还未加载完成时特别有用。
				var $slide_img = $('picture>img', ele)
				if ($slide_img.length) {
					var slide_img = $slide_img.get(0)
					if (slide_img.naturalWidth) {
						$(ele).addClass('img-loaded')
					} else if (slide_img.complete) {
						$(ele).addClass('img-load-error')
					} else {
						$(ele).addClass('img-loading')
					}
				} else {
					$(ele).addClass('img-load-error')
				}
				$slide_img.ifImgLoaded().then(function (result) {
					$(ele).removeClass('img-loading').addClass('img-loaded')
				}).catch(function (error) {
					$(ele).removeClass('img-loading').addClass('img-load-error')
				})
			})

			// 2. 如果没有"slide-nav"则添加(设置"navContainer: '.owl-nav'"后需要)，且最小化首屏绘制过程中呈现内容过大变化。
			if (slider_options.navContainer && !$('.owl-nav', $Slider).length) {
				var is_show_nav = slider_options.nav
				if (slider_options.responsive) {
					var breakpoints = slider_options.responsive
					for (var key in breakpoints) {
						if (window.innerWidth < key) continue
						if (Object.hasOwnProperty.call(breakpoints, key)) {
							var value = breakpoints[key]
							if (value && value.hasOwnProperty('nav')) {
								is_show_nav = value.nav
							}
						}
					}
				}
				if (is_show_nav) {
					$Slider.append('<div class="owl-nav"><div class="owl-prev"></div><div class="owl-next"></div></div>')
				}
			}
		})
		$sliderOwl.on('initialized.owl.carousel', function (event) {
			// 清除原来用于提前在初始化前就显示的导航内容（Owl添加导航是在"initialized.owl.carousel"之后执行）
			$('.owl-nav', $Slider).empty()
		})
		$sliderOwl.owlCarousel(slider_options)
	}

	$('.brands111').owlCarousel({
		loop: true,
		nav: false,
		navText: ['', ''],
		dots: false,
		autoplay: true,
		autoplayTimeout: 800,
		autoplaySpeed: 300,
		slideSpeed: 500,
		smartSpeed: 500,
		//rewindSpeed: 1000,

		//slideTransition: 'linear',
		//items: 10,
		margin: 25,
		thumbs: false,
		responsive: {
			0: {
				items: 3,
			},
			330: {
				items: 5,
			},
			541: {
				items: 6,
			},
			992: {
				items: 8,

			},
			1401: {
				items: 12,
			}
		},
	});

	$('.blog').owlCarousel({
		loop: false,
		nav: true,
		navText: ['', ''],
		dots: false,
		autoplay: false,
		autoplayTimeout: 3000,
		items: 3,
		margin: 20,
		thumbs: false,
		responsive: {
			0: {
				items: 1,
				dots: true,
			},
			541: {
				items: 2,
				dots: true,
			},
			992: {
				items: 3,

			}
		},
	});

	$('.hocl-posts').owlCarousel({
		loop: false,
		nav: true,
		navText: ['', ''],
		dots: true,
		autoplay: false,
		autoplayTimeout: 3000,
		items: 2,
		margin: 20,
		thumbs: false,
		responsive: {
			0: {
				items: 1,
			},
			541: {
				items: 2,
			},
			992: {
				items: 2,

			}
		},
	});

	$('.catalogs').owlCarousel({
		loop: false,
		nav: true,
		navText: ['', ''],
		dots: false,
		autoplay: false,
		autoplayTimeout: 3000,
		items: 3,
		margin: 20,
		thumbs: false,
		responsive: {
			0: {
				items: 1,
				dots: true,
				nav: false,
			},
			340: {
				items: 2,
				dots: true,
				nav: false,
			},
			992: {
				items: 3,
			}
		},
	});

	$('.parents').owlCarousel({
		loop: false,
		nav: true,
		navText: ['', ''],
		dots: false,
		autoplay: false,
		autoplayTimeout: 3000,
		items: 6,
		margin: 20,
		thumbs: false,
		responsive: {
			0: {
				items: 1,
				dots: true,
			},
			330: {
				items: 2,
				dots: true,
			},
			992: {
				items: 3,
			},
			1441: {
				items: 6,
			}
		},
	});

	//产品主图缩略图超出容器时，设置箭头、拖动、滚轮处理
	function getThumbsOrientationByPreset(obj) {
		var orientation, isParamOk = false, defaultObj = { 0: 'x', 768: 'y' }
		if (obj && ['string', 'object'].indexOf(typeof obj) >= 0) {
			if (typeof obj === 'string') {
				replace_reg = /(?:({|,)\s*)(\d+)(?=\s*:)/g
				if (replace_reg.test(obj)) {
					obj = obj.replace(/'/g, '"').replace(/(?:({|,)\s*)(\d+)(?=\s*:)/g, ', "$2"')
					if (obj.slice(0, 2) === ', ') {
						obj = '{' + obj.slice(2)
					}
				}
				try {
					obj = JSON.parse(obj)
				} catch (e) { }
			}
			if (Object.prototype.toString.call(obj) === '[object Object]' &&
				Object.getOwnPropertyNames(obj).length && !(obj instanceof jQuery) && !obj.target
			) {//排除数组、HTML元素、jQuery、event等对象
				isParamOk = true
			}
		}
		if (!isParamOk) {
			obj = defaultObj
		}
		for (var key in obj) {
			if (!isNaN(key) && Object.hasOwnProperty.call(obj, key)) {
				if (window.innerWidth >= key) {
					orientation = obj[key]
				}
			}
		}
		return orientation
	}
	function getThumbsOrientation(box) {
		if (box instanceof jQuery) box = box.get(0)
		if (!box) return false
		var parent = box.parentElement,
			parentWidth = parent.offsetWidth,
			parentHeight = parent.offsetHeight,
			orientation = ''
		if (parentWidth > parentHeight) {
			orientation = 'x'
		} else if (parentWidth < parentHeight) {
			orientation = 'y'
		}
		return orientation
	}
	function handleViewMoreThumbs(settings) {
		var defaults = {
			"thumbs_wrapper": '',
			"thumbs_box": '',
			"thumb_nav_container_class": 'owl-thumbs-nav'
		},
			data
		if (!settings) {
			return
		} else if ($.isPlainObject(settings)) {
			data = settings
		} else if ($ && settings instanceof jQuery.Event) {
			data = settings.data ? settings.data : arguments[1] //前者在on上传递，后者在trigger时传递
		} else if (settings instanceof Event) {
			if (window.attachEvent) {//IE
				data = msData //需监听回调函数传递参数msData且返回本函数
			} else {
				data = this.data //监听器为包含handleEvent()的对象且对象属性为data
			}
		}
		data = $.extend({}, defaults, data)
		var $thumbs_wrapper = data.thumbs_wrapper,
			$thumbs_box = data.thumbs_box,
			isParamOk = false
		if ($thumbs_wrapper instanceof jQuery && $thumbs_box instanceof jQuery) {
			isParamOk = true
		} else if ($thumbs_wrapper instanceof HTMLElement && $thumbs_box instanceof HTMLElement) {
			isParamOk = true
			$thumbs_wrapper = $($thumbs_wrapper)
			$thumbs_box = $($thumbs_box)
		}
		if (!isParamOk || !$thumbs_wrapper.length || !$thumbs_box.length) return
		var thumbs_wrapper = $thumbs_wrapper.get(0),
			thumbs_wrapper_rect = thumbs_wrapper.getBoundingClientRect(),
			thumbs_box = $thumbs_box.get(0),
			thumbs_box_rect = thumbs_box.getBoundingClientRect(),
			orientation = getThumbsOrientation(thumbs_box),
			$thumb_items = $thumbs_box.children(),
			first_thumb_item = $thumb_items.first().get(0),
			last_thumb_item = $thumb_items.last().get(0),
			first_thumb_rect = first_thumb_item.getBoundingClientRect(),
			last_thumb_rect = last_thumb_item.getBoundingClientRect(),
			isViewMore = false
		if (thumbs_box_rect.left < thumbs_wrapper_rect.left ||
			thumbs_box_rect.top < thumbs_wrapper_rect.top) {
			return //防止应用到新版产品详情页
		}
		switch (orientation) {
			case 'x':
				if (last_thumb_rect.right > thumbs_wrapper_rect.right || first_thumb_rect.left < thumbs_wrapper_rect.left) {
					isViewMore = true
				}
				break
			case 'y':
				if (last_thumb_rect.bottom > thumbs_wrapper_rect.bottom || first_thumb_rect.top < thumbs_wrapper_rect.top) {
					isViewMore = true
				}
				break
			default:
				break
		}
		if (isViewMore) {
			//清理resize前的旧样式、设置新样式，设置offsetSize，更新上下箭头
			if (!data.global.sanitizeStyle) {
				data.global.sanitizeStyle = $.debounce(function () {
					var moved_axis = thumbs_box.getAttribute('moved-axis')
					if (moved_axis) {
						var previous_rect_data = data.previous_rect_data,
							previous_wrapper_rect = previous_rect_data.thumbs_wrapper_rect,
							previous_first_in_sight_rect = previous_rect_data.first_in_sight_rect,
							previous_orientation = previous_rect_data.orientation,
							previous_offset = previous_rect_data.offset,
							old_moved_value,
							old_first_in_sight_over,
							split_rate
						switch (previous_orientation) {
							case 'x':
								old_moved_value = previous_offset.left
								old_first_in_sight_over = previous_wrapper_rect.left - previous_first_in_sight_rect.left
								if (old_first_in_sight_over < 1) {
									old_first_in_sight_over = 0
								}
								split_rate = old_first_in_sight_over / previous_first_in_sight_rect.width
								break
							case 'y':
								old_moved_value = previous_offset.top
								old_first_in_sight_over = previous_wrapper_rect.top - previous_first_in_sight_rect.top
								if (old_first_in_sight_over < 1) {
									old_first_in_sight_over = 0
								}
								split_rate = old_first_in_sight_over / previous_first_in_sight_rect.height
								break
						}
						var orientation = getThumbsOrientation(thumbs_box)
						switch (orientation) {
							case 'x':
								thumbs_box.style.top = ''
								thumbs_box.style.height = '100%'
								break
							case 'y':
								thumbs_box.style.left = ''
								thumbs_box.style.height = ''
								break
						}
						var first_in_sight = thumbs_box.querySelector('[first-in-sight]'),
							first_in_sight_rect = first_in_sight.getBoundingClientRect(),
							now_moved_value
						switch (orientation) {
							case 'x':
								if (split_rate) {
									now_moved_value = (first_in_sight_rect.width * split_rate) * old_moved_value / old_first_in_sight_over
								} else {
									now_moved_value = thumbs_box_rect.left - first_in_sight_rect.left
								}
								thumbs_box.style.left = now_moved_value + 'px'
								break
							case 'y':
								if (split_rate) {
									now_moved_value = (first_in_sight_rect.height * split_rate) * old_moved_value / old_first_in_sight_over
								} else {
									now_moved_value = thumbs_box_rect.top - first_in_sight_rect.top
								}
								thumbs_box.style.top = now_moved_value + 'px'
								break
						}
					}
				}, 500) //至少500，原因是受thumbs_box.style.position在sanitizeStyle中有被改变的影响，取消absolute后left或top失效，即有一个先齐顶再移动效果。
			}
			data.global.sanitizeStyle()
			if (!data.global.setOffsetSize) {
				data.global.setOffsetSize = $.debounce(function () {
					var offsetSize = {}, //offsetWidth和offsetHeight分别受width和height样式影响外，当限定width则还受position样式影响，因此需提前获取并设置
						is_changed_style = false,
						position_old_value, width_old_value
					if (thumbs_box.getAttribute('moved-axis')) {
						var boxStyle = getComputedStyle(thumbs_box)
						position_old_value = boxStyle.position
						if (thumbs_box.style.cssText.indexOf('width:') >= 0) {
							width_old_value = thumbs_box.style.cssText.split('width:').pop().trim().split(';').shift()
						}
						if (position_old_value === 'absolute' || width_old_value) {
							if (position_old_value === 'absolute') {
								//即使在box元素无width:100%且flex-shrink:0设置下，只要position:absolute，getBoundingClientRect()获取的宽度仍然可能不是完整宽
								//而且此处修改会导致1次相关样式失效的过渡，后期可酌情将absolute改为relative可以避免这两个问题
								thumbs_box.style.position = ''
							}
							if (width_old_value) {
								//即使在flex-shrink:0;position:static设置下，若设置有width，getBoundingClientRect()获取的宽度仍然是可见宽
								thumbs_box.style.width = ''
							}
							is_changed_style = true
						}
					}
					offsetSize.width = thumbs_box.offsetWidth
					offsetSize.height = thumbs_box.offsetHeight
					setTimeout(function () {
						if (is_changed_style) {
							if (position_old_value) {
								thumbs_box.style.position = position_old_value
							}
							if (width_old_value) {
								thumbs_box.style.width = width_old_value
							}
						}
						thumbs_box.setAttribute('offset-size', JSON.stringify(offsetSize))
					}, 500)
				}, 1000)
			}
			data.global.setOffsetSize()
			if (!data.global.syncPrevNext) {
				data.global.syncPrevNext = $.debounce(function () {
					var navPrevNext = thumbs_wrapper.querySelector('nav-prev-next')
					if (navPrevNext && navPrevNext.hasAttribute('orientation')) {
						navPrevNext.setAttribute('orientation', getThumbsOrientation(thumbs_box))
					}
				}, 500)
			}
			data.global.syncPrevNext()

			var view_modes = $thumbs_box.attr('view-modes') || '',
				_view_modes = []

			// 上下箭头
			var navPrevNextTag = 'nav-prev-next'
			if (!customElements.get(navPrevNextTag)) {
				class navPrevNext extends HTMLElement {
					constructor() {
						super()
						this.constructor.init()
					}

					static get observedAttributes() {
						return ['orientation']
					}

					static init() { //this为类本身，非静态方法中this为实例
						if (!this.template) {
							this.template = document.createElement('template')
							this.template.innerHTML = `
							<style>
								.wrapper {
									display: flex;
									justify-content: center;
									align-items: center;
									height: 100%;
								}
								button {
									position: absolute; /*决定wrapper的orientation属性值*/
									padding: 0;
									border: 0;
									background: transparent;
									cursor: pointer;
								}
								:host([orientation=x]) .prev {
									left: 0;
								}
								:host([orientation=x]) .next {
									right: 0;
								}
								:host([orientation=y]) .prev {
									top: 0;
								}
								:host([orientation=y]) .next {
									bottom: 0;
								}
								.visually-hidden {
									display: block;
									width: 1px;
									height: 1px;
									padding: 0;
									margin: -1px;
									overflow: hidden;
									clip: rect(0, 0, 0, 0);
									white-space: nowrap;
									border: 0;
								}
								::slotted(svg) {
									width: 36px;
									height: 36px;
									border-radius: 50%;
									color: white;
									background: rgb(0 0 0 / .5);
								}
							</style>
							<div class="wrapper">
								<button class="prev" type="button">
									<span class="prev-icon" aria-hidden="true"><slot name="prev">Requires slot support.</slot></span>
									<span class="visually-hidden">Previous</span>
								</button>
								<button class="next" type="button">
									<span class="next-icon" aria-hidden="true"><slot name="next">Requires slot support.</slot></span>
									<span class="visually-hidden">Next</span>
								</button>
							</div>
							`
						}
						if (!this.navPrev) {
							this.navPrev = {
								up: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-circle" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z"/>
</svg>`, left: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"/>
</svg>`
							}
						}
						if (!this.navNext) {
							this.navNext = {
								down: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-circle" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z"/>
</svg>`, right: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"/>
</svg>`
							}
						}
					}

					renderShadow() {
						this.attachShadow({ mode: "open" }) //有shadowRoot时，即使影子内部没有slot槽位，自定义元素内影子外的元素将不可视。
						var template = this.constructor.template
						this.shadowRoot.appendChild(template.content.cloneNode(true))
					}

					createElementByString(str) {
						var div = document.createElement('div')
						div.innerHTML = str
						return div.children[0]
					}

					getDefaultIcons() {
						var constructor = this.constructor,
							icons = { "prev": constructor.navPrev.up, "next": constructor.navNext.down }
						if (this.parentWidth > this.parentHeight) {
							icons.prev = constructor.navPrev.left
							icons.next = constructor.navNext.right
						}
						return icons
					}

					setDefaultIcons() {
						var defaultIcons = this.getDefaultIcons(),
							prev = this.createElementByString(defaultIcons.prev),
							next = this.createElementByString(defaultIcons.next)
						prev.setAttribute('slot', 'prev')
						next.setAttribute('slot', 'next')
						this.appendChild(prev)
						this.appendChild(next)
						return { "prev": prev, "next": next }
					}

					setDOMAttribute() {//实例属性
						this.parentWidth = parseFloat(getComputedStyle(this.parentElement).width) ||
							parseFloat(getComputedStyle(this.parentElement.parentElement).width)
						this.parentHeight = parseFloat(getComputedStyle(this.parentElement).height) ||
							parseFloat(getComputedStyle(this.parentElement.parentElement).height)
					}

					initHTMLAttribute() {
						this.doingInitAttributes = ['icon-source', 'orientation']
						this.doingInitAttributes.forEach(function (ele, i) {
							switch (ele) {
								case 'icon-source':
									if (this.children.length) {
										this.setAttribute(ele, 'custom')
									} else {
										this.setAttribute(ele, 'default')
									}
									break
								case 'orientation':
									if (this.parentWidth > this.parentHeight) {
										this.setAttribute(ele, 'x')
									} else if (this.parentWidth < this.parentHeight) {
										this.setAttribute(ele, 'y')
									}
									break
							}
						}, this)
						delete this.doingInitAttributes
					}

					connectedCallback() {//无论是DOM结构中事先存在还是通过JS添加，它都会运行。
						if (this.getAttribute('useShadowRoot') !== 'false') {
							this.renderShadow()
							this.setDOMAttribute()
							this.initHTMLAttribute()
							if (!this.children.length) {
								this.setDefaultIcons()
								// prev.classList.add('hidden')
								this.querySelector('[slot=prev]').style.display = 'none'
							}
						}
					}

					attributeChangedCallback(name, oldValue, newValue) {
						if (this.doingInitAttributes) return
						if (name === 'orientation') {
							this.setDOMAttribute()
							var icon_source = this.getAttribute('icon-source'),
								oldPrev = this.querySelector('[slot=prev]'),
								oldNext = this.querySelector('[slot=next]'),
								newPrev, newNext
							switch (icon_source) {
								case 'custom':
									if (newValue === 'x') {
										newPrev = this.querySelector('[class*=left]')
										newNext = this.querySelector('[class*=right]')
									} else if (newValue === 'y') {
										newPrev = this.querySelector('[class*=up]')
										newNext = this.querySelector('[class*=down]')
									}
									break
								default:
									// this.innerHTML = ''
									var icons = this.setDefaultIcons()
									newPrev = icons.prev
									newNext = icons.next
									break
							}
							if (oldPrev.style.display === 'none') {
								newPrev.style.display = 'none'
							}
							if (oldNext.style.display === 'none') {
								newNext.style.display = 'none'
							}
							if (icon_source === 'default') {
								this.removeChild(oldPrev)
								this.removeChild(oldNext)
							} else {
								oldPrev.removeAttribute('slot')
								oldNext.removeAttribute('slot')
							}
							newPrev.setAttribute('slot', 'prev')
							newNext.setAttribute('slot', 'next')
						}
					}
				}
				customElements.define(navPrevNextTag, navPrevNext)
			}
			if (!$thumbs_wrapper.has(navPrevNextTag).length) {
				var thumbs_nav = document.createElement(navPrevNextTag),
					thumb_nav_container_class = data.thumb_nav_container_class,
					$thumb_nav_container = thumb_nav_container_class ? $('.' + thumb_nav_container_class) : $thumbs_wrapper
				$thumb_nav_container.append(thumbs_nav)
			}
			if (view_modes.indexOf('prevNext') < 0) {
				_view_modes.push('prevNext')
				$(navPrevNextTag, thumbs_wrapper).on('click', data, function (eve) {
					var orientation = getThumbsOrientation(thumbs_box),
						$clickedIcon = $(eve.target).closest('[slot]'),
						action = $clickedIcon.attr('slot'),
						style = {
							'position': 'absolute',
							// 'width': '100%',
							'transition': 'none'
						},
						style_all = $thumbs_box.get(0).style,
						first_in_sight = 'first-in-sight', //主要用于确定一次应该移动的距离，特别是项目不等高的情况，虽也可作为箭头显示隐藏的判断但不建议
						$first_in_sight = $('[' + first_in_sight + ']', thumbs_box),
						thumbs_wrapper_rect = thumbs_wrapper.getBoundingClientRect(),
						first_thumb_rect = first_thumb_item.getBoundingClientRect(),
						last_thumb_rect = last_thumb_item.getBoundingClientRect(),
						old_offset,
						offset_diff
					if (orientation === 'x') {
						old_offset = parseFloat($thumbs_box.css('left')) || 0
						//如果有top值则清掉(产生于resize)
						if (style_all.top !== '') {
							style_all.top = ''
						}
						style.height = '100%'
					} else if (orientation === 'y') {
						old_offset = parseFloat($thumbs_box.css('top')) || 0
						//如果有left值清掉(产生于resize)
						if (style_all.left !== '') {
							style_all.left = ''
						}
						if (style_all.height !== '') {
							style_all.height = ''
						}
					}
					var is_move = false,  //防止图标隐藏前的连续点击
						is_change_first_in_sight = false,
						is_show_sibling_icon = false,
						is_hide_self_icon = false
					switch (action) {
						case 'prev':
							if (orientation === 'x') {
								if (0.5 < thumbs_wrapper_rect.left - first_thumb_rect.left) {
									is_move = true
									if (first_thumb_rect.right > thumbs_wrapper_rect.left) {
										offset_diff = thumbs_wrapper_rect.left - first_thumb_rect.left
									} else {
										offset_diff = $first_in_sight.prev().outerWidth(true)
										is_change_first_in_sight = true
									}
									style.left = old_offset + offset_diff
									if (last_thumb_rect.right + offset_diff > thumbs_wrapper_rect.right) {
										is_show_sibling_icon = true
									}
									if (first_thumb_rect.left + offset_diff >= thumbs_wrapper_rect.left) {
										is_hide_self_icon = true
									}
								}
							} else if (orientation === 'y') {
								if (0.5 < thumbs_wrapper_rect.top - first_thumb_rect.top) {
									is_move = true
									if (first_thumb_rect.bottom > thumbs_wrapper_rect.top) {
										offset_diff = thumbs_wrapper_rect.top - first_thumb_rect.top
									} else {
										offset_diff = $first_in_sight.prev().outerHeight(true)
										is_change_first_in_sight = true
									}
									style.top = old_offset + offset_diff
									if (last_thumb_rect.bottom + offset_diff > thumbs_wrapper_rect.bottom) {
										is_show_sibling_icon = true
									}
									if (first_thumb_rect.top + offset_diff >= thumbs_wrapper_rect.top) {
										is_hide_self_icon = true
									}
								}
							}
							if (is_change_first_in_sight) {
								$first_in_sight.removeAttr(first_in_sight).prev().attr(first_in_sight, '')
							}
							break
						case 'next':
							if (orientation === 'x') {
								if (last_thumb_rect.right - thumbs_wrapper_rect.right > 0.5) {
									is_move = true
									if (last_thumb_rect.left < thumbs_wrapper_rect.right) {
										offset_diff = last_thumb_rect.right - thumbs_wrapper_rect.right
									} else {
										offset_diff = $first_in_sight.outerWidth(true)
										is_change_first_in_sight = true
									}
									style.left = old_offset - offset_diff
									if (first_thumb_rect.left - offset_diff < thumbs_wrapper_rect.left) {
										is_show_sibling_icon = true
									}
									if (last_thumb_rect.right - offset_diff <= thumbs_wrapper_rect.right) {
										is_hide_self_icon = true
									}
								}
							} else if (orientation === 'y') {
								if (last_thumb_rect.bottom - thumbs_wrapper_rect.bottom > 0.5) {
									is_move = true
									if (last_thumb_rect.top < thumbs_wrapper_rect.bottom) {
										offset_diff = last_thumb_rect.bottom - thumbs_wrapper_rect.bottom
									} else {
										offset_diff = $first_in_sight.outerHeight(true)
										is_change_first_in_sight = true
									}
									style.top = old_offset - offset_diff
									if (first_thumb_rect.top - offset_diff < thumbs_wrapper_rect.top) {
										is_show_sibling_icon = true
									}
									if (last_thumb_rect.bottom - offset_diff <= thumbs_wrapper_rect.bottom) {
										is_hide_self_icon = true
									}
								}
							}
							if (is_change_first_in_sight) {
								$first_in_sight.removeAttr(first_in_sight).next().attr(first_in_sight, '')
							}
							break
						default:
					}
					if (is_move) {
						$thumbs_box.css(style).attr('moved-axis', orientation)
						if (is_show_sibling_icon) {
							$clickedIcon.siblings().finish().fadeTo('slow', 1) //使用fadeIn有2次闪烁
						}
						if (is_hide_self_icon) {
							$clickedIcon.fadeOut()
						}
						var $first_in_sight = $('[' + first_in_sight + ']', thumbs_box)
						if (is_change_first_in_sight) {
							$first_in_sight.trigger('click') //必须获取最新的first_in_sight
						}
						var data = eve.data
						if (data && data.previous_rect_data) { //用于resize时first_in_sight项目与包裹器的放置切合
							data.previous_rect_data.first_in_sight_rect = $first_in_sight.get(0).getBoundingClientRect()
							data.previous_rect_data.thumbs_wrapper_rect = thumbs_wrapper_rect
							var offsetLT = data.previous_rect_data.offset
							if (orientation === 'x') {
								offsetLT.left = style.left
							} else if (orientation === 'y') {
								offsetLT.top = style.top
							} else {
								offsetLT.left = style.left
								offsetLT.top = style.top
							}
						}
					}
				})
			}

			// PC拖动
			if (view_modes.indexOf('drag') < 0) {
				_view_modes.push('drag')
				$thumbs_box.css({ cursor: 'move' }).on('mousedown', data, doDragThumbs)
			}

			// 移动触摸
			if (view_modes.indexOf('touch') < 0) {
				var touch,
					isPointerSupported = window.PointerEvent || window.MSPointerEvent,
					isTouchSupported = 'ontouchstart' in window || navigator.msMaxTouchPoints
				if (isPointerSupported) {
					touch = 'pointerdown'
				} else if (isTouchSupported) {
					touch = 'touchstart'
				}
				if (touch) {
					_view_modes.push('touch')
					$thumbs_box.on(touch, data, doTouchThumbs)
				}
			}

			// 鼠标滚轮
			if (view_modes.indexOf('wheel') < 0) {
				_view_modes.push('wheel')
				var wheel_cb = function (event) { //节流不要直接给到wheel_cb，否则仅滚动缩略图元素却未能成功阻止默认和冒泡即会连带滚动整个文档
					event.preventDefault()
					event.stopPropagation()
					var throttle_fn = $.throttle(doWheelThumbs, 300)
					throttle_fn(event)
				}
				$thumbs_wrapper.on('mouseenter', function (eve) {
					$thumbs_box.on('wheel', data, wheel_cb)
				})
				$thumbs_wrapper.on('mouseleave', function (eve) {
					$thumbs_box.off('wheel', wheel_cb)
				})
			}

			if (!view_modes) {
				$thumbs_box.attr('view-modes', _view_modes.join())
			}
		}
	}
	function doMoveThumbs(box, move_data, source_event) {
		if (!box || !move_data || !(box instanceof HTMLElement) || typeof move_data !== 'object') return
		if (!(typeof move_data.x === 'number' && typeof move_data.y === 'number')) {
			move_data = { x: 0, y: 0 }
		}
		var orientation = getThumbsOrientation(box),
			moveX = move_data.x,
			moveY = move_data.y
		//当通过鼠标滚轮移动时，Chrome浏览器每次滚轮滚动的deltaY始终为100（向下）-100（向上），因此仅使每次滚动上下移动一个项目
		if (source_event.type === 'wheel') {
			if (orientation === 'x') {
				moveX = move_data.y
				moveY = move_data.x
			}
			if (moveX !== 0) {
				moveX = moveX > 0 ? 1 : -1
			}
			if (moveY !== 0) {
				moveY = moveY > 0 ? 1 : -1
			}
		}
		if (moveX !== 0 || moveY !== 0) {
			var thisWidth = box.offsetWidth, //box.offsetWidth无法包含溢出部分的高度（原因：width:100%;），否则若脱离文档流则还需"flex-shrink: 0"
				thisHeight = box.offsetHeight, //box.offsetHeight包含溢出部分的高度(原因：height未设置)
				boxStyle = getComputedStyle(box),
				boxParentStyle = getComputedStyle(box.parentElement)
			if (box.style.position && parseFloat(boxStyle.width) <= parseFloat(boxParentStyle.width)) {
				// box.style.width = ''
				var offsetSize = box.getAttribute('offset-size')
				try {
					offsetSize = JSON.parse(offsetSize)
				} catch (e) { }
				if (typeof offsetSize === 'object') {
					thisWidth = Math.max(offsetSize.width, thisWidth)
					thisHeight = Math.max(offsetSize.height, thisHeight)
				}
			}
			var startLeft = box.offsetLeft, //滚动对象
				startTop = box.offsetTop,
				endLeft = startLeft + moveX,
				endTop = startTop + moveY,
				thumbs_wrapper = box.parentElement,
				containerWidth = thumbs_wrapper.offsetWidth,
				containerHeight = thumbs_wrapper.offsetHeight,
				children = box.children,
				first_child = box.firstElementChild,
				last_child = box.lastElementChild,
				thumbs_wrapper_rect = thumbs_wrapper.getBoundingClientRect(),
				first_thumb_rect = first_child.getBoundingClientRect(),
				last_thumb_rect = last_child.getBoundingClientRect(),
				first_in_sight_str = 'first-in-sight',
				first_in_sight //使用querySelector查找时，又mousemove太快可能属性还设置好
			for (var i = 0; i < children.length; i++) {
				var child = children[i],
					child_rect = child.getBoundingClientRect(),
					is_ok = false
				if (orientation === 'x' && child_rect.right > thumbs_wrapper_rect.left ||
					orientation === 'y' && child_rect.bottom > thumbs_wrapper_rect.top) {
					is_ok = true
				}
				if (is_ok) {
					first_in_sight = child
					break
				}
			}
			var is_calculate = false,
				sibling = first_in_sight
			switch (orientation) {
				case 'x':
					var maxMoveX = thisWidth - containerWidth
					if (moveX === 0 || maxMoveX <= 0) return
					//初始状态时不能向右拖动/滚动，最后一项在容器末端时不能再向左拖动/滚动，endTop恒为0
					if (moveX > 0) {//向右拖/滚
						if (first_thumb_rect.right > thumbs_wrapper_rect.left) endLeft = 0
						else is_calculate = true
					} else {//向左拖/滚
						if (last_thumb_rect.left < thumbs_wrapper_rect.right) endLeft = -maxMoveX
						else is_calculate = true
					}
					if (is_calculate) {
						//此时startLeft一定为负数或0
						//moveX > 0，向右拖/滚，则计算firstInSight左侧多少个元素的（宽度+外边距）和>=moveX
						//moveX < 0，向左拖/滚，则计算firstInSight及其右侧多少个元素的（宽度+外边距）和>= -moveX
						var moveW = 0
						while ((sibling = moveX > 0 ? sibling.previousElementSibling : sibling)) {
							var sibling_style = getComputedStyle(sibling),
								marginLeft = parseFloat(sibling_style.marginLeft),
								marginRight = parseFloat(sibling_style.marginRight)
							moveW += sibling.offsetWidth + marginLeft + marginRight //注意避免margin重叠
							if (moveX > 0) {//向右拖/滚
								if (!sibling.previousElementSibling) {//当拖动/滚动距离（moveX）较大，而由于又没有足够多的上一个兄弟元素供遍历，因此第一项如果有超出容器的部分无法随拖动齐平
									if (moveW < moveX) { //按元素高移动距离不够鼠标移动/滚动距离
										moveW = -startLeft
										break
									}
								}
								if (moveW >= moveX) break
							} else {//向左拖/滚
								if (moveW - startLeft > maxMoveX) {//当拖动距离（-moveX）较大，而由于又有足够多的下一个兄弟元素供遍历，因此最后一项在容器末端时还会向上前进
									moveW = startLeft + maxMoveX
									break
								}
								sibling = sibling.nextElementSibling
								if (moveW >= -moveX) break
							}
						}
						endLeft = moveX > 0 ? startLeft + moveW : startLeft - moveW
					}
					box.style.left = endLeft + 'px'
					break
				case 'y':
					var maxMoveY = thisHeight - containerHeight
					if (moveY === 0 || maxMoveY <= 0) return
					//初始状态时不能向下拖动/滚动，最后一项在容器底部时不能再向上拖动/滚动，endLeft恒为0
					if (moveY > 0) {//向下拖/滚
						if (first_thumb_rect.bottom > thumbs_wrapper_rect.top) endTop = 0
						else is_calculate = true
					} else {//向上拖/滚
						if (last_thumb_rect.top < thumbs_wrapper_rect.bottom) endTop = -maxMoveY
						else is_calculate = true
					}
					if (is_calculate) {
						//此时startTop一定为负数或0
						//moveY > 0，向下拖/滚，则计算firstInSight上边多少个元素的（宽度+外边距）和>=moveY
						//moveY < 0，向上拖/滚，则计算firstInSight及其下边多少个元素的（宽度+外边距）和>= -moveY
						var moveH = 0
						while ((sibling = moveY > 0 ? sibling.previousElementSibling : sibling)) {
							var sibling_style = getComputedStyle(sibling),
								marginTop = parseFloat(sibling_style.marginTop),
								marginBottom = parseFloat(sibling_style.marginBottom)
							moveH += sibling.offsetHeight + marginTop + marginBottom //注意避免margin重叠
							if (moveY > 0) {//向下拖/滚
								if (!sibling.previousElementSibling) {//当拖动/滚动距离（moveY）较大，而由于又没有足够多的上一个兄弟元素供遍历，因此第一项如果有超出容器的部分无法随拖动齐平
									if (moveH < moveY) { //按元素高移动距离不够鼠标移动距离
										moveH = -startTop
										break
									}
								}
								if (moveH >= moveY) break
							} else {//向上拖/滚
								if (moveH - startTop > maxMoveY) {//当拖动/滚动距离（-moveY）较大，而由于又有足够多的下一个兄弟元素供遍历，因此最后一项在容器底部时还会向上前进
									moveH = startTop + maxMoveY
									break
								}
								sibling = sibling.nextElementSibling
								if (moveH >= -moveY) break
							}
						}
						endTop = moveY > 0 ? startTop + moveH : startTop - moveH
					}
					box.style.top = endTop + 'px'
					break
				default:
					//拖离边界时预留10px以便回拖
					if (moveX > 0 && endLeft >= containerWidth) {//向右
						endLeft = containerWidth - 10
					} else if (moveX < 0 && endLeft <= -thisWidth) {//向左
						endLeft = -thisWidth + 10
					}
					if (moveY > 0 && endTop >= containerHeight) {//向下
						endTop = containerHeight - 10
					} else if (moveY < 0 && endTop <= -thisHeight) {//向上
						endTop = -thisHeight + 10
					}
					box.style.left = endLeft + 'px'
					box.style.top = endTop + 'px'
					break
			}
			// box.style.width = '100%' //单页测试时当缩略图在X轴方向拖动可能变成2行，现发现多余
			if (orientation === 'x') {
				box.style.height = '100%'
			}
			box.style.position = 'absolute'
			box.style.transition = 'none'
			document.getElementsByTagName("body")[0].style.userSelect = 'none'
			box.setAttribute('moved-axis', orientation)

			//处理"first-in-sight"属性
			if (is_calculate) { //凡经过计算都会至少移动一整个项目，而导致该属性切换
				box.querySelector('[' + first_in_sight_str + ']').removeAttribute(first_in_sight_str)
				//向右或下拖/滚时，左侧或上边超过容器部分够拖，则sibling为真，否则为假
				//向左或上拖/滚时，sibling始终为真
				if (sibling) {
					sibling.setAttribute(first_in_sight_str, '')
				} else {
					first_child.setAttribute(first_in_sight_str, '')
				}
				//处理滚轮移动时，预览图的同步更新
				if (source_event.type === 'wheel') {
					$('[' + first_in_sight_str + ']', box).trigger('click') //必须获取最新的first_in_sight
				}
			}
			var data = source_event.data
			if (data && data.previous_rect_data) { //用于resize时first_in_sight项目与包裹器的放置切合
				data.previous_rect_data.first_in_sight_rect = $('[' + first_in_sight_str + ']', box).get(0).getBoundingClientRect()
				data.previous_rect_data.thumbs_wrapper_rect = thumbs_wrapper_rect
				var offsetLT = data.previous_rect_data.offset
				if (orientation === 'x') {
					offsetLT.left = endLeft
				} else if (orientation === 'y') {
					offsetLT.top = endTop
				} else {
					offsetLT.left = endLeft
					offsetLT.top = endTop
				}
			}

			//处理上下箭头的显示
			var prevAction, nextAction
			first_thumb_rect = first_child.getBoundingClientRect() //必须重新获取
			last_thumb_rect = last_child.getBoundingClientRect()
			if (orientation === 'x') {
				// if (first_thumb_rect.left < thumbs_wrapper_rect.left) prevAction = 'show'
				if ((first_thumb_rect.left / thumbs_wrapper_rect.left).toFixed(2) < 1) prevAction = 'show'
				else prevAction = 'hide'
				// if (last_thumb_rect.right <= thumbs_wrapper_rect.right) nextAction = 'hide'
				// 同为right且最后一个子元素确实在父容器右边的左侧时，然而611.140625 / 611.046875，可能子元素比父元素右边数值大
				// 由于若按项目逐个则定会大较多，若两数相近则定是边挨着，因此toFixed(2)两位足够
				if ((last_thumb_rect.right / thumbs_wrapper_rect.right).toFixed(2) <= 1) nextAction = 'hide'
				else nextAction = 'show'
			} else if (orientation === 'y') {//纵向时暂未出现即不使用toFixed
				if (first_thumb_rect.top < thumbs_wrapper_rect.top) prevAction = 'show'
				else prevAction = 'hide'
				if (last_thumb_rect.bottom <= thumbs_wrapper_rect.bottom) nextAction = 'hide'
				else nextAction = 'show'
			}
			var navPrevNext = box.parentElement.querySelector('nav-prev-next'),
				navPrev = navPrevNext.querySelector('[slot=prev]'),
				navNext = navPrevNext.querySelector('[slot=next]')
			if (prevAction === 'show') {
				$(navPrev).finish().fadeTo('slow', 1)
			} else {
				$(navPrev).fadeOut()
			}
			if (nextAction === 'show') {
				$(navNext).finish().fadeTo('slow', 1)
			} else {
				$(navNext).fadeOut()
			}
		}
	}
	function doDragThumbs(event) {
		var _this = this,
			target = event.target,
			isDragThis = function (e) {
				var draggedObj = [].slice.call(e.target.children).filter(function (ele) {
					return ele.getAttribute('drag-trigger-source')
				}).pop() || e.target
				return draggedObj === _this || isFindElement(_this.childNodes, draggedObj)
			},
			domMousedownHandler = function (e) {
				if (isDragThis(e)) {
					_this.setAttribute('dragging', 'true')
				}
				return false
			},
			domMouseupHandler = function (e) {
				_this.style.pointerEvents = null
				_this.removeAttribute('drag-trigger-source')
				_this.removeAttribute('dragging')
				document.removeEventListener('mousedown', domMousedownHandler)
				document.removeEventListener('mouseup', domMouseupHandler)
				document.removeEventListener('mousemove', domMousemoveHandler)
				document.getElementsByTagName("body")[0].style.userSelect = ''
			},
			domMousemoveHandler = function (e) {
				if (_this.getAttribute('dragging')) {
					var coords = getEventCoords(e),
						endX = coords.x,
						endY = coords.y,
						moveX = endX - startX,
						moveY = endY - startY
					if (!e.data) {
						e.data = event.data
					}
					doMoveThumbs(_this, { x: moveX, y: moveY }, e)
				}
				return false
			}
		addListener(document, 'mousedown', domMousedownHandler)
		addListener(document, 'mouseup', domMouseupHandler)
		var coords = getEventCoords(event),
			startX = coords.x, //鼠标
			startY = coords.y
		//由于设置属性first-in-sight需要时间，因此使用$.throttle会导致querySelector到的元素不一致。另外，就是使用child_rect.bottom方式后也不要用$.throttle，效果不好。
		addListener(document, 'mousemove', domMousemoveHandler)
		// 解决当前拖动元素click触发冲突（其上owlCarousel.Constructor.Plugins.Thumbs绑定了click事件）
		// event.preventDefault() //阻止掉默认带的拖动行为
		this.setAttribute('drag-trigger-source', 'true')
		setTimeout(function () { //由其父元素来触发绑定的监听
			var target = _this.parentElement
			if (target.fireEvent) { //IE
				// var event = document.createEventObject()
				// event.type = 'mousedown'
				// document.body.fireEvent('onmousedown', event)
				target.fireEvent('onmousedown')
			} else {
				target.dispatchEvent(new MouseEvent('mousedown', {
					bubbles: true,
					cancelable: true,
					view: window,
				}))
			}
		})
		// 解决点击不在thumbItem或mousedown+mouseup不在同一项目上时导致无法确定当前项因而始终切换到最后一项的问题
		this.style.pointerEvents = 'none' //禁用元素鼠标事件，这里是关键，作用此时是阻止触发click事件
		if (this !== target) {
			var clickedThumbItem,
				thumbItems = [].slice.call(this.children)
			for (var i = 0; i < thumbItems.length; i++) {
				var thumbItem = thumbItems[i]
				if (thumbItem === target || isFindElement([].slice.call(thumbItem.children), target)) {
					clickedThumbItem = thumbItem
					break
				}
			}
			if (clickedThumbItem) {
				if (target.fireEvent) { //IE
					target.fireEvent('onclick')
				} else {
					target.dispatchEvent(new MouseEvent('click', {
						bubbles: true, //默认值为 false
						cancelable: true, //默认值为 false
						view: window,
					}))
				}
			}
		}
		return false //比event.preventDefault()程度更深，它只能阻止拖动或文本选择等默认行为，而click虽等于mousedown+mouseup但不属于其默认行为，即它不会阻止click。
	}
	function doWheelThumbs(event) {
		var origin_event = event instanceof jQuery.Event ? event.originalEvent : event
		doMoveThumbs(event.currentTarget, { x: -origin_event.deltaX, y: -origin_event.deltaY }, event)
	}
	function doTouchThumbs(event) {
		console.log(event)
		var origin_event = event instanceof jQuery.Event ? event.originalEvent : event,
			type = event.type
		switch (type) {
			case 'pointerdown':
				break
			case 'touchstart':
				break
		}
	}
	if ($('.product-info').length) {
		var $preview_img_box = $('#slider-product'),
			$thumbs_box = $('.owl-thumbs'),
			$thumbs_wrapper,
			preview_img_promise,
			thumbs_promise,
			img_promises = []
		if ($preview_img_box.length) {
			var preview_img = $('img', $preview_img_box).get(0) //在owlCarousel初始化之前执行则不会是克隆的第一个img
			if (preview_img) {
				preview_img_promise = $(preview_img).ifImgLoaded()
				if (!(preview_img_promise instanceof Error)) {
					img_promises.push(preview_img_promise)
				}
			}
		}
		if ($thumbs_box.length) {
			$thumbs_wrapper = $thumbs_box.parent()
			var thumb_imgs = $.makeArray($('img', $thumbs_box)),
				thumb_img_promises = thumb_imgs.map(function (ele, i) {
					return $(ele).ifImgLoaded()
				})
			if (thumb_img_promises.length) {
				thumbs_promise = Promise.all(thumb_img_promises)
				img_promises.push(thumbs_promise)
			}
		}
		if (img_promises.length > 1) {
			Promise.all(img_promises).then(function (value) {
				var resize = 'resize.thumbs.product',
					thumbs_wrapper = $thumbs_wrapper.get(0),
					first_in_sight = $('[first-in-sight]', $thumbs_box).get(0),
					data = {
						"thumbs_wrapper": $thumbs_wrapper,
						"thumbs_box": $thumbs_box,
						"global": {},
						"previous_rect_data": {
							//图片虽已加载完成，但整个页面可能还未渲染完整，因此thumbs_wrapper_rect数据会变化，从而当sanitizeStyle中计算移动距离时会错误即须在移动相关操作中还需同时更新它
							"thumbs_wrapper_rect": thumbs_wrapper ? thumbs_wrapper.getBoundingClientRect() : null,
							"first_in_sight_rect": first_in_sight ? first_in_sight.getBoundingClientRect() : null,
							"orientation": getThumbsOrientation($thumbs_box),
							"offset": { "left": 0, "top": 0 } //相对其父元素偏移
						}
					}
				$(window).on(resize, data, handleViewMoreThumbs).trigger(resize) //on上的data为event.data，而trigger上的data为arguments[1]
			})
		}
		$preview_img_box.owlCarousel({
			loop: true,
			dots: false,
			nav: false,
			autoplay: false,
			items: 1,
			thumbs: true, //启用后才开始监听"owl-thumbs"的点击
			thumbImage: false,
			thumbsPrerendered: true,
			animateOut: 'fadeOut'
		});
	}
	// -------------------- rating --------------------------

	$(".rating").each(function () {

		var agregate = $(this).find('.rating-agregate').text();
		var fulles = 5;
		var rightes = (agregate / fulles) * 100;
		$(this).find('.progress').css("width", rightes + '%');
	});
	// -------------------- Tabs -------------------------

	(function ($) {
		jQuery.fn.lightTabs = function (options) {

			var createTabs = function () {
				tabs = this;
				i = 0;

				showPage = function (i) {
					$(tabs).children("div").children("div").hide();
					$(tabs).children("div").children("div").eq(i).show();
					$(tabs).find("ul.tabs-list").children("li").removeClass("active");
					$(tabs).find("ul.tabs-list").children("li").eq(i).addClass("active");
				}

				showPage(0);

				$(tabs).find("ul.tabs-list").children("li").each(function (index, element) {
					$(element).attr("data-page", i);
					i++;
				});

				$(tabs).find("ul.tabs-list").children("li").click(function () {
					let img = $(this).attr("data-img");
					$('.widgets-qute .image img').attr('src', img);
					showPage(parseInt($(this).attr("data-page")));
					/*if ($(this).data('page') != '3') {
						$.each(players, function (n) {
							for (let j = 0; j < players.length; j++) {
								players[j].pause();
							}
						});
					}*/
				});
			};
			return this.each(createTabs);
		};

	})(jQuery);

	$('.tabs').lightTabs();
	// -------------------- Heart -------------------------

	function initparticles() {
		hearts();
		prrs();
	}

	function hearts() {
		$.each($(".particletext.hearts"), function () {
			var heartcount = ($(this).width() / 50) * 5;
			for (var i = 0; i <= heartcount; i++) {
				var size = ($.rnd(60, 120) / 10);
				$(this).append('<span class="particle" style="top:' + $.rnd(20, 80) + '%; left:' + $.rnd(0, 95) + '%;width:' + size + 'px; height:' + size + 'px;animation-delay: ' + ($.rnd(0, 30) / 10) + 's;"></span>');
			}
		});
	}
	function prrs() {
		$.each($(".particletext.prr"), function () {
			var heartcount = ($(this).width() / 50) * 5;
			for (var i = 0; i <= heartcount; i++) {
				var size = ($.rnd(60, 120) / 10);
				$(this).append('<span class="particle" style="top:' + $.rnd(20, 80) + '%; left:' + $.rnd(0, 95) + '%;width:' + size + 'px; height:' + size + 'px;animation-delay: ' + ($.rnd(0, 30) / 10) + 's;"></span>');
			}
		});
	}
	jQuery.rnd = function (m, n) {
		m = parseInt(m);
		n = parseInt(n);
		return Math.floor(Math.random() * (n - m + 1)) + m;
	}

	initparticles();



	// -------------------- more -------------------------

	let showChar = 80;
	let dots = "...";
	let moreText = "Read more";
	let lessText = "Hide";

	$('.short-description').each(function () {
		var content = $(this).html();

		if (content.length > showChar) {

			var cont = content.substr(0, showChar);
			var restOfTheText = content.substr(showChar, content.length - showChar);

			var html = cont + '<span class="dots">' + dots + '</span><span class="morecontent"><span>' + restOfTheText + '</span><a href="" class="morelink">' + moreText + '</a></span>';

			$(this).html(html);
		}

	});

	$(".morelink").click(function () {
		if ($(this).hasClass("test")) {
			$(this).removeClass("test");
			$(this).html(moreText);
		} else {
			$(this).addClass("test");
			$(this).html(lessText);
		}
		$(this).parent().prev().toggle();
		$(this).prev().toggle();
		return false;
	});

	// -------------------- Scroll -------------------------

	$('.srolls').on('click', 'a', function (event) {
		// 排除标准浏览器反应
		event.preventDefault()

		// href属性的接收标识符
		var id = $(this).attr('href'),
			// 我们找到了积木所在的高度。
			top

		if ($(id).length) {
			top = $(id).offset().top - 100

			// 动画切换到单元，时间:800毫秒
			$('body,html').animate({ scrollTop: top }, 800)
		}
	})

	$('.tabs-product li').on('click', function (event) {
		$(this).addClass('active');
		$(this).siblings().removeClass('active');
	});
	// -------------------------modal----------------------

	$('.to-state').on('click', function (event) {
		event.preventDefault()
		$('div').removeClass('active')
		$('.state').removeClass('active')
		var state = $(this).attr('data-state')
		$('.state[data-state=' + state + ']').addClass('active')
	})

	$('.close').on('click', function (event) {
		$(this).parents().removeClass('active')
	})

	jQuery(function ($) {
		$(document).mouseup(function (e) { // 网络文件点击事件
			var div = $(".state-box"); // 这里显示元素ID。
			if (!div.is(e.target) // 如果点击不是我们的块
				&& div.has(e.target).length === 0) { // 而不是它的子元素。
				div.parents().removeClass('active');
			}
		});
	});
	// -------------------- Acordion -------------------------


	$(".accordion").each(function () {

		var acc = document.getElementsByClassName("accordion-box");
		var i;

		for (i = 0; i < acc.length; i++) {
			acc[i].addEventListener("click", function () {
				this.classList.toggle("active");
				//var panel = this.nextElementSibling;
				var panel = this.querySelector('.accordion-body');
				if (panel.style.maxHeight) {
					panel.style.maxHeight = null;
				} else {
					panel.style.maxHeight = panel.scrollHeight + "px";
				}
			});
		}

	});
	// -------------------- Tabs -------------------------

	(function ($) {
		jQuery.fn.lightTabs = function (options) {

			var createTabs = function () {
				tabs = this;
				i = 0;

				showPage = function (i) {
					$(tabs).children("div").children("div").hide();
					$(tabs).children("div").children("div").eq(i).show();
					$(tabs).find("ul.tabs-list").children("li").removeClass("active");
					$(tabs).find("ul.tabs-list").children("li").eq(i).addClass("active");
				}

				showPage(0);

				$(tabs).find("ul.tabs-list").children("li").each(function (index, element) {
					$(element).attr("data-page", i);
					i++;
				});

				$(tabs).find("ul.tabs-list").children("li").click(function () {

					showPage(parseInt($(this).attr("data-page")));
					/*if ($(this).data('page') != '3') {
						$.each(players, function (n) {
							for (let j = 0; j < players.length; j++) {
								players[j].pause();
							}
						});
					}*/
				});
			};
			return this.each(createTabs);
		};
	})(jQuery);

	$('.tabs').lightTabs();

	//---------Reviews-----------
	$['toggle_fold_reviews'] = function () {

		let reviews_grid = document.querySelector('.reviews-grid'), data = Array.from(reviews_grid.querySelectorAll('.item')), step;

		if (document.documentElement.clientWidth > 992) {
			step = 6
		} else if (document.documentElement.clientWidth > 680) {
			step = 3
		} else {
			step = 2
		}

		let toggle = function (status) {
			let items = data.slice(step)
			if (status === 'fold') {
				items.forEach(e => e.style.display = 'none');
			} else if (status === 'unfold') {
				items.forEach(e => e.style.display = 'block');
			}
		},
			btn_more = document.querySelector('#more'),
			click_cb = function (e) {
				let status = this.getAttribute('status')
				status = !status || status === 'fold' ? 'unfold' : 'fold'
				this.setAttribute('status', status)
				toggle(status)
				this.value = this.value === 'More' ? 'Less' : 'More'
			}

		// btn_more.removeEventListener('click', click_cb)
		// btn_more.addEventListener('click', click_cb); //由于每次function时click_cb是一个新的对象，因此即使先移除监听再添加也无效，实际一个找不到回调相当于没移除。
		btn_more.onclick = click_cb

		if (data.length > step) {
			if (!btn_more.getAttribute('status')) {
				toggle('fold')
			}
			btn_more.removeAttribute('style')
		} else {
			btn_more.style.display = 'none'
		}

	}
	$(".reviews-grid").each($.toggle_fold_reviews);

	/* 	function transferWidget() {
			if (document.documentElement.clientWidth <= 767) {
				$('.product-info .short-description').prependTo($('.product-info .images'));
				$('.product-info .rating').prependTo($('.product-info .images'));
				$('.product-info .product-title').prependTo($('.product-info .images'));
			} else {
				$('.product-info .short-description').prependTo($('.product-info .block'));
				$('.product-info .rating').prependTo($('.product-info .block'));
				$('.product-info .product-title').prependTo($('.product-info .block'));
			}
		}
		transferWidget();
	
		$(window).resize(function () {
			transferWidget();
		}); */

	//--------------- video---------------






	function findVideos() {
		let videos = document.querySelectorAll('.video');

		for (let i = 0; i < videos.length; i++) {
			setupVideo(videos[i]);
		}
	}

	function setupVideo(video) {
		let link = video.querySelector('.video__link');
		let media = video.querySelector('.video__media');
		let button = video.querySelector('.video__button');
		let id = parseMediaURL(media);

		video.addEventListener('click', () => {


			let iframe = createIframe(id);
			link.remove();
			button.remove();
			video.appendChild(iframe);

		});

		link.removeAttribute('href');
		video.classList.add('video--enabled');

	}

	function parseMediaURL(media) {
		let regexp = /https:\/\/i\.ytimg\.com\/vi\/([a-zA-Z0-9_-]+)\/maxresdefault\.jpg/i;
		let url = $('.video__media').attr('data-src');
		let match = url.match(regexp);

		return match[1];
	}

	function createIframe(id) {
		let iframe = document.createElement('iframe');

		iframe.setAttribute('allowfullscreen', '');
		iframe.setAttribute('allow', 'autoplay');
		iframe.setAttribute('src', generateURL(id));
		iframe.classList.add('video__media');

		return iframe;
	}

	function generateURL(id) {
		let query = '?rel=0&showinfo=0&autoplay=1';

		return 'https://www.youtube.com/embed/' + id + query;
	}

	findVideos();

	// ------------------- Range-sliders -----------------------

	$(".range-slider-wrap").each(function () {


		var $range = $(this).find(".js-range-slider"),
			$inputFrom = $(this).find(".js-input-from"),
			$inputTo = $(this).find(".js-input-to"),



			instance,
			min = $inputFrom.attr("min"),
			max = $inputTo.attr("max"),
			from = $inputFrom.val(),
			to = $inputTo.val();




		$range.ionRangeSlider({
			skin: "round",
			type: "double",
			min: min,
			max: max,
			from: from,
			to: to,
			onStart: updateInputs,
			onChange: updateInputs
		});

		instance = $range.data("ionRangeSlider");

		function updateInputs(data) {
			from = String(data.from).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
			to = String(data.to).replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');


			$inputFrom.prop("value", from);
			$inputTo.prop("value", to);
		}

		$inputFrom.on("input", function () {
			var val = Number($(this).prop("value"));

			// validate
			if (val < min) {
				val = min;
			} else if (val > to) {
				val = to;
			}

			instance.update({
				from: val
			});
		});

		$inputTo.on("input", function () {
			var val = Number($(this).prop("value"));

			// validate
			if (val < from) {
				val = from;
			} else if (val > max) {
				val = max;
			}

			instance.update({
				to: val
			});
		});

	});
	//end
})

$.extend({
	debounce: function (fn, wait) {
		let t
		return function (...args) {
			clearTimeout(t)
			t = setTimeout(() => fn.apply(this, args), wait)
		}
	},
	throttle: function (fn, delay) {
		let lastCall = 0
		return function (...args) {
			const now = new Date().getTime()
			if (now - lastCall < delay) {
				return
			}
			lastCall = now
			return fn(...args)
		}
	},
	inMenuLevel: function (item) {
		let matches = /level-(\d+)/.exec($(item).parent().attr("class")) //返回数组或null，因此用let而不用const，另外正则表达式不能加引号变为字符串
		return matches && matches.length > 1 ? matches[1] : -1 //matches[1]类型为字符串
	},
	toHTMLElementArray: function (eles) {
		if (!Array.isArray(eles)) {
			if (eles instanceof jQuery) {
				eles = eles.get()
			} else if (eles instanceof HTMLElement) {
				eles = [eles]
			} else {
				eles = []
			}
		} else {
			eles = eles.filter(function (ele) {
				return ele instanceof HTMLElement
			})
		}
		return eles
	},
	setInputQuantity: function (inputs, operator, baseSelf) {
		inputs = $.toHTMLElementArray(inputs)
		if (!inputs.length || !operator) return
		if (typeof baseSelf !== 'boolean') baseSelf = false
		const get_new_val = function (old_val, operator) {
			let new_val
			switch (operator) {
				case '+':
					new_val = old_val + 1
					break
				case '-':
					new_val = old_val - 1
					new_val = new_val < 1 ? 1 : new_val
					break
				case 'reset':
					new_val = 1
					break
				default:
					new_val = old_val
			}
			return new_val
		}
		let old_val, new_val
		if (!baseSelf) {
			if (operator === 'manual') {
				new_val = Math.abs(parseInt(inputs[0].value)) || 1
			} else {
				old_val = Math.abs(parseInt(inputs[0].value)) || 1
				new_val = get_new_val(old_val, operator)
			}
			for (let i = 0, len = inputs.length; i < len; i++) {
				$(inputs[i]).val(new_val)
			}
		} else {
			for (let i = 0, len = inputs.length; i < len; i++) {
				const input = inputs[i]
				old_val = Math.abs(parseInt(input.value)) || 1
				new_val = get_new_val(old_val, operator)
				$(input).val(new_val)
			}
		}
	},
	setSessionCache: function (key, value) {
		try {
			if (!value) return false
			let now = new Date()
			let jsonData = JSON.stringify({ time: now, data: value })

			sessionStorage.setItem(key, jsonData)
			return true
		} catch (e) {
			return false
		}
	},
	getSessionCache: function (key) {
		try {
			let jsonObjectString = sessionStorage.getItem(key)
			let parsedData = JSON.parse(jsonObjectString)

			return parsedData.data
		} catch (e) {
			return null
		}
	},
	/*function expireSessionCache() {
	  let totalStorageLen = sessionStorage.length
	  let now = new Date()
	  let maxAge = 1000 * 60 * 60 * 24 // 1 day
	
	  for (let i = 0; i < totalStorageLen; i++) {
		let itemKey = sessionStorage.key(i)
		let itemData = sessionStorage.getItem(itemKey)
	
		try {
		  let parsedData = JSON.parse(itemData)
		  let itemCacheTime = new Date(parsedDate.time)
		  let timeDifference = now.valueOf() - imageCacheTime.valueOf()
	
		  if (timeDifference > maxAge) {
			sessionStorage.removeItem(itemKey)
		  }
		} catch (e) {
	
		}
	  }
	}*/
	getImgDataBase64: function (img) {
		img = img instanceof jQuery ? img.get(0) : img
		/*img.loading = 'lazy'
		img.crossOrigin = "anonymous" //解决下面两种使用画布的情况时，提示被污染错误（图片资源跨域问题）：Tainted canvases may not be exported. 注意：图片设置任何属性都会引起重新加载，导致naturalWidth此时为0而width却是400，虽可结合loading=lazy使用以避免再次加载，但是不太好（后该为：new的直接在修改src后立马修改时间太快也只请求一次，提前预加载或加载完成的图片在标签上提前加好crossOrigin属性）。另外，调试时还需注意是否勾选"Disable Cache"。lazy的图片加载时发起者为，Chrome：other，Firefox：lazy-iamgeset*/
		if (img.complete) {
			const canvas = document.createElement("canvas"),
				width = img.naturalWidth,
				height = img.naturalHeight
			canvas.width = width
			canvas.height = height
			canvas.getContext("2d").drawImage(img, 0, 0, width, height) //将图片绘制到画布中
			try {
				return canvas.toDataURL('image/webp') //转换图片为dataURL，如果传入的类型非"image/png"，但是返回的值以"data:image/png"开头，那么该传入的类型浏览器不支持。注意：canvas元素只要被定义，无需设置其他属性已经可以使用canvas.toDataURL。
			} catch (e) {
				return false
			}
		}
		return ''
	},
	classNameMatch: function (ele, reg) {
		ele = ele instanceof jQuery ? ele.get(0) : ele
		return ele.className.match(reg)
	},
	ulLiShowCount: function (ul) {
		const $box = $(ul).first(),
			$ele = $box.children("li:not(.visually-hidden)").first(),
			box_width = $box.width(),
			ele_width = $ele.outerWidth()
		return Math.floor(box_width / ele_width)
	},
	btnsPrevNext: function (box) {
		return $("button", box).filter(function () {
			return this.className.match(/prev|next/i)
		})
	},
	clickPrevNext: function (eve) {
		const $box = $(this).parent().parent(),
			$ul = $box.find("ul").first(),
			$lis = $ul.children("li:not(.visually-hidden)"),
			$first = $lis.first(), //const last = lis.eq(small_picture.num_showed-1)
			config = {
				// container: product_info
				container: $box
			},
			prev_next_bs_tooltip = function (ele, config) {
				const tooltip = new bootstrap.Tooltip(ele, config)
				//bootstrap.Tooltip.getOrCreateInstance(this,config).show()
				tooltip.show()
				setTimeout(function (e) {
					tooltip.dispose()
				}, 3000)
			}
		if (this.className.indexOf('prev') !== -1) {
			const $prev = $first.prev()
			if ($prev.length) {
				$prev.removeClass("visually-hidden")
				$(this).siblings("button").removeClass("text-secondary").addClass("text-primary").removeAttr("disabled")
			} else {
				if (USE_BOOTSTRAP_JS) {
					config.title = 'No Prev'
					config.placement = 'left'
					prev_next_bs_tooltip(this, config)
				} else {
					$(this).removeClass("text-primary").addClass("text-secondary").prop("disabled", true)
				}
			}
		} else if (this.className.indexOf('next') !== -1) {
			if ($lis.length > $.ulLiShowCount(ul)) {
				$first.addClass("visually-hidden")
				$(this).siblings("button").removeClass("text-secondary").addClass("text-primary").removeAttr("disabled")
			} else {
				if (USE_BOOTSTRAP_JS) {
					config.title = 'No Next'
					config.placement = 'right'
					prev_next_bs_tooltip(this, config)
				} else {
					$(this).removeClass("text-primary").addClass("text-secondary").prop("disabled", true)
				}
			}
		}
	},
	resizePrevNext: function (box) {
		let _$prev_next = $.btnsPrevNext(box),
			$prev_next = _$prev_next
		const $ul = $("ul", box),
			$prev_next_parent = $prev_next.parent()
		if ($prev_next_parent.length === 1 && $prev_next_parent.children().length === 2) {
			$prev_next = $prev_next_parent
		}
		if ($("li", $ul).length > $.ulLiShowCount($ul)) {
			$prev_next.attr("style", $.attrCbStyleShow).show()
			_$prev_next.off("click").on("click", $.clickPrevNext)
		} else {
			$prev_next.hide().attr("style", $.attrCbStyleHide)
		}
	},
	attrCbStyleHide: function (index, style) {
		return style ? style.replace(/(display:\s*none)(?!!)/i, '$1!important') : ''
	},
	attrCbStyleShow: function (index, style) {
		return style ? style.replace(/(display:\s*none)\s*!important/i, '$1') : ''
	},
	bulkChangeClass: function (ref, act, cls) {
		if (!ref || ['show', 'hide', ''].indexOf(act) === -1) return
		if (!(ref instanceof jQuery)) {
			ref = $(ref)
		}
		const show = { "add": "d-block", "remove": "d-none" },
			hide = { "add": "d-none", "remove": "d-block" },
			_cls = {}
		Object.defineProperties(_cls, {
			'self': { writable: true, enumerable: true },
			'siblings': { writable: true, enumerable: true },
			'parent': { writable: true, enumerable: true }
		})
		Object.seal(_cls)
		if (act) {
			_cls.self = act === 'show' ? show : hide
			_cls.siblings = act === 'show' ? hide : show
		}
		cls = Object.assign(_cls, cls)
		if (Object.getOwnPropertyNames(cls).length) {
			for (const key in cls) {
				if (cls.hasOwnProperty(key) && cls[key]) {
					let add = cls[key]['add'],
						remove = cls[key]['remove'],
						target
					if (act) {
						if (!add) {
							if (key === 'self') {
								add = act === 'show' ? "d-block" : "d-none"
							} else if (key === 'siblings') {
								add = act === 'show' ? "d-none" : "d-block"
							}
						}
						if (!remove) {
							if (key === 'self') {
								remove = act === 'show' ? "d-none" : "d-block"
							} else if (key === 'siblings') {
								remove = act === 'show' ? "d-block" : "d-none"
							}
						}
					}
					switch (key) {
						case 'self':
							target = ref
							break
						case 'siblings':
							target = ref.siblings()
							break
						case 'parent':
							target = ref.parent()
							break
						default:
					}
					target.addClass(add).removeClass(remove)
				}
			}
		}
	},
	updateTopCart: function (json) {
		const $cart = $("#cart"),
			$cart_item_count = $(".cart-item-count", $cart),
			$cart_total_price = $(".cart-total-price", $cart),
			symbol = $cart_total_price.text().charAt(0)
		try {
			var total_price = window.Shopify.formatMoney(json.total_price, symbol + "\{\{amount\}\}")
		} catch (error) {
			console.log(error)
		}
		$cart_item_count.text(json.item_count)
		$cart_total_price.text(total_price)
	},
	changeCartLineItem: function (eve) {
		if (!eve) return
		const $tr = $(eve.currentTarget).closest('tr'),
			$td_totals = $tr.find(".cart-item__totals"),
			$td_totals_status = $td_totals.children("[role=status]"),
			post_status_class = {
				self: { add: "position-absolute mt-1", remove: "d-none" },
				siblings: { add: "opacity-0" }
			},
			line = $tr.attr("id").split("-").pop(),
			getSectionID = function (ref) {
				return ref ? $(ref).closest('.shopify-section').attr('id').replace('shopify-section-', '') : ''
			},
			getSectionsToRender = function () {
				return [
					{
						id: 'cart_form',
						section: getSectionID('#cart_form'),
						selector: 'table'
					},
					{
						id: 'cart-icon-bubble',
						section: 'cart-icon-bubble',
						selector: '.cart-count-bubble'
					},
					{
						id: 'cart-live-region-text',
						section: 'cart-live-region-text',
						selector: '.shopify-section'
					},
					{
						id: 'cart-footer',
						section: getSectionID('#cart-footer'),
						selector: '.cart-totals'
					}
				]
			},
			getSectionInnerHTML = function (html, selector) {
				return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
			}
		let quantity
		if (eve.type === 'click') {
			quantity = $(eve.currentTarget).siblings("[type=number]").val()
		} else {
			quantity = $(eve.currentTarget).val()
		}
		$.bulkChangeClass($td_totals_status, '', post_status_class)
		$.post(window.Shopify.routes.root + 'cart/change.js', {
			line: line,
			quantity: quantity, //obfuscator加密不支持$.post(url,data)中data对象的简写形式，即使将该对象赋值一个变量放到外面也报错(quantity is not defined)，与是let还是const的变量无关。
			sections: getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname
		}, null, 'json').done(function (data) {
			try {
				data = JSON.parse(data)
			} catch (e) { }
			getSectionsToRender().forEach((section) => {
				const elementToReplace =
					document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)
				elementToReplace.innerHTML = getSectionInnerHTML(
					data.sections[section.section],
					section.selector
				)
			})
		})
	},
	confirmMessage: function (eve) {
		let msg = eve.currentTarget.dataset.confirmMessage
		if (!msg || msg.indexOf("missing") !== -1) msg = "Are you sure?"
		if (!confirm(msg)) eve.preventDefault()
	},
	showFormReminder: function (config) {
		var default_cfg = {
			action: '',
			status: '',
			message: ''
		}
		if (Object.prototype.toString.call(config) === '[object Object]' && Object.getOwnPropertyNames(config).length) {
			config = Object.assign({}, default_cfg, config)
			// 修改样式，使用固定宽高的容器而非全屏覆盖
			var wrapper_style = 'position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);z-index:99999;pointer-events:none;',
				inner_style = 'display:flex;justify-content:center;align-items:center;gap:6px;min-width:200px;padding:8px 16px;background:rgb(12 12 12 / .75);border-radius:5px;font-size:16px;text-align:center;text-transform:capitalize;pointer-events:auto;',
				text = config.message ? config.message : config.status,
				icon
			if (config.status === 'success') {
				inner_style += 'color:#20E7B2;'
				icon = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">\n' +
					'  <path d="M16.5 3.885L7.9425 12.45L4.7625 9.27L5.82 8.2125L7.9425 10.335L15.4425 2.835L16.5 3.885ZM14.8425 7.665C14.94 8.0925 15 8.5425 15 9C15 12.315 12.315 15 9 15C5.685 15 3 12.315 3 9C3 5.685 5.685 3 9 3C10.185 3 11.28 3.345 12.21 3.9375L13.29 2.8575C12.075 2.0025 10.5975 1.5 9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 8.1075 16.335 7.2525 16.05 6.4575L14.8425 7.665Z" fill="#20E7B2"/>\n' +
					'</svg>'
			} else if (config.status === 'error') {
				inner_style += 'color:#FF3636;'
				icon = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">\n' +
					'  <path d="M10.9425 6L9 7.9425L7.0575 6L6 7.0575L7.9425 9L6 10.9425L7.0575 12L9 10.0575L10.9425 12L12 10.9425L10.0575 9L12 7.0575L10.9425 6ZM9 1.5C4.8525 1.5 1.5 4.8525 1.5 9C1.5 13.1475 4.8525 16.5 9 16.5C13.1475 16.5 16.5 13.1475 16.5 9C16.5 4.8525 13.1475 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z" fill="#FF3636"/>\n' +
					'</svg>'
			} else {
				inner_style += 'color:white;'
			}
			switch (config.action) {
				case 'add-cart':
					if (!config.message) {
						if (config.status === 'error') {
							text += ': lack of stock'
						} else if (config.status === 'cache') {
							text = 'Invalid: purchase is caching'
						} else if (config.status === 'success') {
							// 成功添加到购物车后更新购物车数量
							updateCartCount();
						}
					}
					break;
				case 'subscribe':
					break
				default:
					break
			}

			// 移除已存在的提示
			$('#form-reminder').remove();

			var div = document.createElement('div');
			var div_child = div.cloneNode();
			div.id = 'form-reminder';
			div.setAttribute('style', wrapper_style);
			div.setAttribute('action', config.action);
			div_child.setAttribute('style', inner_style);
			$(div_child).append('<span>' + text + '</span>').prepend(icon);
			div.appendChild(div_child);
			document.body.appendChild(div);

			// 使用 setTimeout 确保动画完成后移除元素
			setTimeout(function() {
				$('#form-reminder').fadeOut(1500, function() {
					$(this).remove();
				});
			}, 1500);
		}
	}
})
$.fn.extend({
	timedFadeOut: function (seconds = 1600) {
		let selector = this,
			timeoutID = setTimeout(function () {
				clearTimeout(timeoutID)
				$(selector).stop().fadeOut()
			}, seconds) //停止滚动2s后再次隐藏，其中fadeOut默认使用400毫秒的延时
		return this
	},
	ifImgLoaded: function () {
		var image = this.get(0)
		if (!(image instanceof HTMLImageElement)) {
			return Promise.reject(new TypeError('The target should be an image.'));
		}
		var promise = new Promise(function (resolve, reject) {
			if (image.naturalWidth) {
				resolve(image)
			} else if (image.complete) {
				reject(image)
			} else {
				$(image).on('load', fulfill)
				$(image).on('error', fulfill)
			}
			function fulfill() {
				if (image.naturalWidth) {
					resolve(image)
				} else {
					reject(image)
				}
				$(image).off('load', fulfill)
				$(image).off('error', fulfill)
			}
		})
		return $.extend(promise, { image: image })
	}
})

$(function () {
	const USE_BOOTSTRAP_JS = typeof bootstrap === 'object' //bootstrap支持鼠标键盘控制
	Shopify.money_format = "${{amount}}"
	Shopify.formatMoney = function (cents, format) {
		if (typeof cents == 'string') { cents = cents.replace('.', ''); }
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || this.money_format);
		function defaultOption(opt, def) {
			return (typeof opt == 'undefined' ? def : opt);
		}
		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal = defaultOption(decimal, '.');
			if (isNaN(number) || number == null) { return 0; }
			number = (number / 100.0).toFixed(precision);
			var parts = number.split('.'),
				dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
				cents = parts[1] ? (decimal + parts[1]) : '';

			return dollars + cents;
		}
		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}
		return formatString.replace(placeholderRegex, value);
	}

	// 表单验证提示自定义
	const forms_to_validate = document.querySelectorAll('.needs-validation')
	if (forms_to_validate.length) {
		Array.prototype.slice.call(forms_to_validate)
			.forEach(function (form) {
				const fields_selector = '[name*=comment\\[]',
					submit_cb = function (event) {
						$(fields_selector, this).removeClass("is-valid is-invalid")
						if (this.dataset.commentPage === 'article') {
							const email = document.querySelector("#comment_form input[name='comment[email]']")//querySelector选择器未找到返回null，若是用jQuery查询返回空对象然而它用if判断为真需改为length。
							if (email.value && !email.value.match(/(.+)@([\w-]+\.)+[a-zA-Z]{2,}/)) {
								email.value = email.value.replaceAll(' ', '-_-') + '@test.com'
								$(email).after('<input type="text" class="form-control shadow-none" value="' + email.value.replace('@test.com', '') + '">').addClass("visually-hidden")
							}
						}
						if (!this.checkValidity()) {
							event.preventDefault()
							event.stopPropagation()
							const $post_status = $(".post-status", this)
							if ($post_status.length) {
								$post_status.remove()
							}
						}
						this.classList.add('was-validated')
					}
				$(form).on('submit', submit_cb)
				$(fields_selector, form).on('change keyup paste', function (event) {
					$(this).removeClass("is-valid is-invalid")
				})
				$("input[name=decline]", form).on("click", function () {
					$(form).off("submit", submit_cb)
				})
			})
	}
})

// 更新购物车数量的函数
function updateCartCount() {
	return fetch(window.Shopify.routes.root + 'cart.js')
		.then(response => {
		if (!response.ok) throw new Error('Cart fetch failed');
		return response.json();
		})
		.then(cart => {
		const cartIconBubble = document.querySelector('#cart-icon-bubble');
		const existingBubble = cartIconBubble?.querySelector('.cart-count-bubble');
		
		if (cartIconBubble && existingBubble) {
			existingBubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
			// 只有当有商品时才添加显示class
			if (cart.item_count > 0) {
			existingBubble.classList.add('is-loaded');
			} else {
			existingBubble.classList.remove('is-loaded');
			}
		}
		})
		.catch(error => {
		console.error('Error updating cart count:', error);
		});
}

// 添加购物车相关的全局函数
window.addToCart = function(form) {
const formData = {
	items: [{
	id: $(form).find('[name="id"]').val(),
	quantity: parseInt($(form).find('[name="quantity"]').val() || 1)
	}]
};

fetch(window.Shopify.routes.root + 'cart/add.js', {
	method: 'POST',
	headers: {
	'Content-Type': 'application/json'
	},
	body: JSON.stringify(formData)
})
.then(response => {
	$.showFormReminder({
	action: 'add-cart',
	status: response.status === 304 ? 'cache' : response.ok ? 'success' : 'error'
	});
	if (response.status === 304) {
	return null;
	} else if (response.ok) {
	updateCartCount();
	return response.json();
	} else {
	throw new Error('Response failure');
	}
})
.catch(error => console.error(error));
};

// 页面加载时初始化购物车数量
document.addEventListener('DOMContentLoaded', updateCartCount);

// 添加到购物车后更新数量
$('form.product-form').on('submit', function(e) {
  e.preventDefault();
  const form = $(this);
  const formData = {
    items: [{
      id: form.find('[name="id"]').val(),
      quantity: parseInt(form.find('[name="quantity"]').val() || 1)
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    $.showFormReminder({
      action: 'add-cart',
      status: response.status === 304 ? 'cache' : response.ok ? 'success' : 'error'
    });
    if (response.status === 304) {
      return null;
    } else if (response.ok) {
      updateCartCount();
      return response.json();
    } else {
      throw new Error('Response failure');
    }
  })
  .then(data => {
    if (data) {
      // 处理返回数据
    }
  })
  .catch(error => console.error(error));
});
